import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Checkbox, Text, VStack } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { CypressIds } from '../../constants/cypressIds';
import { updateModalOptions } from '../../redux/modules/modal';
import ProcoreWritebackWarning from '../ProcoreWritebackWarning';

const ConfirmActionWarningModal = ({ description, procoreWarning }) => {
  const [isChecked, setIsChecked] = useState(false);
  const dispatch = useDispatch();

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
    dispatch(updateModalOptions(
      { buttons: { primaryButtonOptions: { isDisabled: isChecked } } }
    ));
  };

  return (
    <VStack py={2} spacing={4}>
      <Text>
        {description}
      </Text>
      {procoreWarning && (
        <ProcoreWritebackWarning
          affectedRecords={procoreWarning.affectedRecords}
          scope={procoreWarning.scope}
          onDismissChange={procoreWarning.onDismissChange}
        />
      )}
      <Checkbox onChange={handleCheckboxChange}>
        <Text
          data-cy={CypressIds.understandIrreversibleCheckbox}
          textStyle="bodyMd500"
        >
          I understand this action is irreversible.
        </Text>
      </Checkbox>
    </VStack>
  );
};

ConfirmActionWarningModal.propTypes = {
  /** Description of irreversible action */
  description: PropTypes.string,
  /** When set, also warns that Procore insurance rows will be removed */
  procoreWarning: PropTypes.shape({
    scope: PropTypes.oneOf(['record', 'job', 'department', 'insured']).isRequired,
    affectedRecords: PropTypes.number,
    onDismissChange: PropTypes.func
  })
};

export default ConfirmActionWarningModal;
